<div class="card entity-management-card" [style.height]="containerHeight" [ngStyle]="componentColourStyles">

  <!-- Loading Overlay -->
  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- Header Bar -->
  <div class="entity-card-header" *ngIf="data?.header">
    <div class="header-left">
      <ng-container *ngFor="let dropdown of data.header.dropdowns">
        <div class="header-dropdown">
          <label>{{ dropdown.label }}</label>
          <div class="custom-dropdown" [style.width]="dropdown.width || dropdown.dropdownWidth">
            <button
              type="button"
              class="custom-dropdown-trigger"
              (click)="toggleHeaderDropdown(dropdown.key, $event)">
              <span>{{ getDropdownSelectedLabel(dropdown, currentFilters[dropdown.key]) }}</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <div class="custom-dropdown-panel" *ngIf="isHeaderDropdownOpen(dropdown.key)" (click)="$event.stopPropagation()">
              <input
                class="custom-dropdown-search"
                type="text"
                placeholder="Search"
                [value]="getDropdownSearchControl(dropdown.key).value || ''"
                (input)="setDropdownSearchTerm(dropdown.key, $any($event.target).value)">
              <button type="button" class="custom-dropdown-option is-placeholder">
                --Select--
              </button>
              <button
                type="button"
                class="custom-dropdown-option"
                *ngFor="let option of getFilteredDropdownOptions(dropdown)"
                [class.selected]="isHeaderDropdownOptionSelected(dropdown, option)"
                (click)="selectHeaderDropdownOption(dropdown, option)">
                <span>{{ getDropdownOptionLabel(dropdown, option) }}</span>
                <mat-icon *ngIf="isHeaderDropdownOptionSelected(dropdown, option)">check</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="header-center">
      <span class="header-title">{{ headerTitle }}</span>
    </div>

    <div class="header-right">
      <ng-container *ngFor="let action of data.header.actions">
        <!-- Custom Download Popover Toggle -->
        <span class="header-action-wrapper" [class.filter-applied-wrapper]="isFilterActionApplied(action)">
          <div class="download-container" *ngIf="action.actionId === 'download'; else standardAction">
            <button
              class="header-icon"
              mat-icon-button
              [class.filter-applied]="isFilterActionApplied(action)"
              [disabled]="isHeaderActionDisabled(action)"
              (click)="toggleDownloadMenu($event)"
              [attr.aria-label]="action.tooltip || action.actionId"
              [matTooltip]="isFilterActionApplied(action) ? '' : action.tooltip">
              <mat-icon [class]="action.iconClass || ''">{{ action.icon }}</mat-icon>
            </button>

            <!-- Dropdown popup -->
            <div class="download-dropdown"
                 *ngIf="showDownloadMenu"
                 [style.position]="'fixed'"
                 [style.top.px]="downloadMenuTop"
                 [style.right.px]="downloadMenuRight"
                 [style.left]="'auto'"
                 (click)="$event.stopPropagation()">
              <button type="button" class="download-menu-item" (click)="openDownloadConfirmation(action)">
                <mat-icon>cloud_download</mat-icon>
                <span>Download csv file.</span>
              </button>
            </div>
          </div>

          <ng-template #standardAction>
            <button
              class="header-icon"
              mat-icon-button
              [class.filter-applied]="isFilterActionApplied(action)"
              [disabled]="isHeaderActionDisabled(action)"
              (click)="handleHeaderAction(action.actionId, action)"
              [attr.aria-label]="action.tooltip || action.actionId"
              [matTooltip]="isFilterActionApplied(action) ? '' : action.tooltip">
              <mat-icon [class]="action.iconClass || ''">{{ action.icon }}</mat-icon>
            </button>
          </ng-template>

          <div class="applied-filter-popover" *ngIf="isFilterActionApplied(action)">
            <div class="applied-filter-line" *ngFor="let line of getAppliedFilterSummaryLines()">
              {{ line }}
            </div>
          </div>
        </span>
      </ng-container>
    </div>
  </div>

  <!-- Column Headers — fixed, no scroll, scrollbar does NOT appear here -->
  <div class="entity-thead-container" #entityTheadContainer *ngIf="!loading || records.length > 0">
    <table>
      <thead>
        <tr>
          <th class="status-col" [style.width.px]="columnWidths[0]" [class.frozen-col]="frozenColumnsCount > 0" [style.left.px]="frozenColumnsCount > 0 ? 0 : null"></th>
          <th
            *ngFor="let col of data.columns; let i = index"
            [style.width.px]="columnWidths[i + 1]"
            (click)="col.sortable && sortBy(col.key)"
            [class.sortable]="col.sortable"
            [class.frozen-col]="i < frozenColumnsCount"
            [style.left.px]="i < frozenColumnsCount ? getFrozenColumnLeft(i) : null">
            <div class="header-content">
              <span>{{ getColumnDisplayLabel(col) }}</span>
              <mat-icon *ngIf="col.sortable">{{ getSortIcon(col.key) }}</mat-icon>
            </div>
            <div class="resizer" (mousedown)="onResizeStart($event, i + 1)"></div>
          </th>
        </tr>
      </thead>
    </table>
  </div>

  <!-- Rows only — scrollbar starts here, never touches the column headers above -->
  <div class="entity-table-scroll" (scroll)="syncHeaderScroll($event)">
    <table *ngIf="!loading || records.length > 0">
      <colgroup>
        <col [style.width.px]="columnWidths[0]">
        <col *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]">
      </colgroup>
      <tbody>
        <ng-container *ngIf="!loading">
          <tr
            *ngFor="let record of pagedRecords"
            (click)="selectRecord(record)"
            [class.selected]="record === selectedRecord">
            <td class="status-col" [style.width.px]="columnWidths[0]" [class.frozen-col]="frozenColumnsCount > 0" [style.left.px]="frozenColumnsCount > 0 ? 0 : null">
              <mat-icon class="row-check-icon">check</mat-icon>
            </td>
            <td *ngFor="let col of data.columns; let i = index"
                [style.width.px]="columnWidths[i + 1]"
                [class.frozen-col]="i < frozenColumnsCount"
                [style.left.px]="i < frozenColumnsCount ? getFrozenColumnLeft(i) : null">
                <div class="cell-content">
                  <mat-icon *ngIf="isPricingActionHistoryColumn(col)"
                            class="pricing-action-icon"
                            (click)="onPricingActionIconClick($event, record)">
                    link
                  </mat-icon>
                  <span *ngIf="!isPricingActionHistoryColumn(col)">{{ formatCellValue(record[col.key], col) }}</span>
                </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="!loading && records.length === 0" class="no-records">
      <div class="empty-text">No data to display</div>
      <mat-icon class="empty-icon">extension_off</mat-icon>
    </div>
  </div>

  <!-- Footer -->
  <div class="entity-card-footer" *ngIf="paginationEnabled">
    <div class="pagination-summary">
      <span>Rows: {{ records.length }}</span>
      <span>Page Size: {{ pageSize }}</span>
      <span>Current Page: {{ currentPage }}</span>
    </div>

    <div class="pagination-controls">
      <button type="button" class="pagination-button" (click)="goToFirstPage()" [disabled]="currentPage === 1" aria-label="First page">
        <mat-icon>first_page</mat-icon>
      </button>
      <button type="button" class="pagination-button" (click)="goToPreviousPage()" [disabled]="currentPage === 1" aria-label="Previous page">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        type="button"
        class="pagination-page"
        *ngFor="let page of visiblePageNumbers"
        [class.active]="page === currentPage"
        (click)="goToPage(page)">
        {{ page }}
      </button>
      <button type="button" class="pagination-button" (click)="goToNextPage()" [disabled]="currentPage === totalPages" aria-label="Next page">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button type="button" class="pagination-button" (click)="goToLastPage()" [disabled]="currentPage === totalPages" aria-label="Last page">
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
  </div>

</div>

<!-- Download confirmation dialog -->
<ng-template #downloadConfirmDialog>
  <div class="download-dialog-container">
    <div class="download-dialog-header">
      <div class="dialog-title-wrapper">
        <mat-icon class="title-icon">cloud_download</mat-icon>
        <span class="dialog-title">Download</span>
      </div>
      <button class="dialog-close-btn" (click)="closeDialog(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="download-dialog-content">
      <p class="download-message">Do you want to download {{ records.length }} records ?</p>
    </div>
    
    <div class="download-dialog-actions">
      <button class="btn-no" (click)="closeDialog(false)">No</button>
      <button class="btn-yes" (click)="closeDialog(true, currentDownloadAction)">Yes</button>
    </div>
  </div>
</ng-template>

<!-- Delete confirmation dialog -->
<ng-template #deleteDialog>
  <div class="download-dialog-container">
    <div class="download-dialog-header">
      <div class="dialog-title-wrapper">
        <mat-icon class="title-icon">delete</mat-icon>
        <span class="dialog-title">Delete</span>
      </div>
      <button class="dialog-close-btn" (click)="closeDeleteDialog(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="download-dialog-content">
      <p class="download-message">Do you want to delete?</p>
    </div>

    <div class="download-dialog-actions">
      <button class="btn-no" (click)="closeDeleteDialog(false)">No</button>
      <button class="btn-yes" (click)="closeDeleteDialog(true)">Yes</button>
    </div>
  </div>
</ng-template>

<!-- Settings dialog -->
<ng-template #settingsDialog>
  <div class="settings-dialog-container">
    <div class="settings-dialog-header">
      <span class="dialog-title">Settings</span>
      <button class="dialog-close-btn" (click)="closeSettingsDialog(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="settings-dialog-content">
      <div class="settings-section-card">
        <h4 class="section-card-title">{{ headerTitle || data?.header?.title || 'Entity' }}</h4>
        
        <div class="settings-form-row">
          <label class="form-label">Records per page</label>
          <input type="number" class="form-input" [(ngModel)]="localPageSize">
        </div>
        
        <div class="settings-form-row">
          <label class="form-label">Freeze columns</label>
          <input type="number" class="form-input" [(ngModel)]="localFrozenCols">
        </div>
        
        <div class="settings-form-row">
          <label class="form-label">My defaults</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDefaults">
              <option value="restore">Restore defaults, Pr...</option>
              <option value="save">Save as default</option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="settings-section-card">
        <h4 class="section-card-title">All Entity</h4>
        
        <div class="settings-form-row">
          <label class="form-label">Display format</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDisplayFormat">
              <option value="code_name">Code&#123;Name&#125;</option>
              <option value="code">Code</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>
        
        <div class="settings-checkbox-row native-checkbox-row">
          <input type="checkbox" id="showSystemAttribute" [(ngModel)]="localShowSystemAttribute">
          <label for="showSystemAttribute">Show System Attribute</label>
        </div>
      </div>
    </div>
    
    <div class="settings-dialog-actions">
      <button class="btn-cancel" (click)="closeSettingsDialog(false)">Cancel</button>
      <button class="btn-ok" (click)="closeSettingsDialog(true)">Ok</button>
    </div>
  </div>
</ng-template>

<!-- View Transactions (history) dialog -->
<ng-template #historyDialog>
  <div class="history-dialog-container">
    <div class="history-dialog-header">
      <span class="history-dialog-title">{{ historyDialogTitle }}</span>
    </div>

    <div class="history-table-scroll">
      <table class="history-table">
        <thead>
          <tr>
            <th *ngFor="let col of historyColumns"
                [class.sortable]="col.sortable"
                (click)="col.sortable && sortHistoryBy(col.key)">
              <div class="history-th-content">
                <span>{{ col.label }}</span>
                <mat-icon class="history-sort-icon" *ngIf="col.sortable">swap_vert</mat-icon>
              </div>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="!historyLoading && pagedHistoryRecords.length > 0">
          <tr *ngFor="let row of pagedHistoryRecords">
            <td *ngFor="let col of historyColumns">{{ formatCellValue(row[col.key], col) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="history-loading" *ngIf="historyLoading">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>

      <div class="history-empty-state" *ngIf="!historyLoading && pagedHistoryRecords.length === 0">
        <span>{{ historyEmptyMessage }}</span>
        <mat-icon class="history-empty-icon">extension_off</mat-icon>
      </div>
    </div>

    <div class="history-dialog-footer">
      <span>Rows: {{ historyRecords.length }} | Page Size: {{ historyPageSize }} | Current Page: {{ historyPage }}</span>
    </div>

    <div class="history-annotations" *ngIf="historyAction?.annotations?.enabled !== false">
      <h3 class="history-annotations-title">{{ historyAction?.annotations?.label || 'Annotations' }}</h3>
      <div class="history-annotations-box">
        <div class="history-annotation-line" *ngFor="let note of historyAnnotations">{{ note }}</div>
      </div>
      <div class="history-annotations-add-row">
        <input
          class="history-annotations-input"
          type="text"
          [placeholder]="historyAction?.annotations?.placeholder || 'Add Annotations'"
          [(ngModel)]="newHistoryAnnotation"
          (keyup.enter)="addHistoryAnnotation()">
        <button type="button" class="history-annotations-add-btn" (click)="addHistoryAnnotation()" aria-label="Add annotation">
          <mat-icon>add</mat-icon>
        </button>
        <span class="history-annotations-add-label">{{ historyAction?.annotations?.addButtonLabel || 'Add annotations' }}</span>
      </div>
    </div>

    <div class="history-dialog-actions">
      <button type="button" class="btn-close" (click)="closeHistoryDialog()">Close</button>
    </div>
  </div>
</ng-template>
